import { render, staticRenderFns } from "./airDetails.vue?vue&type=template&id=82f88dd8&scoped=true&"
import script from "./airDetails.vue?vue&type=script&lang=js&"
export * from "./airDetails.vue?vue&type=script&lang=js&"
import style0 from "./airDetails.vue?vue&type=style&index=0&id=82f88dd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f88dd8",
  null
  
)

export default component.exports